import Vue from 'vue'
import App from './App'
import router from './router'
import iView from 'iview';
import {comp_EXP} from '@/assets/api'
import 'iview/dist/styles/iview.css';
import "./assets/common.css";
Vue.config.productionTip = false
Vue.use(iView)
Vue.prototype.host=document.domain.includes('beta_agent')|| document.domain=='127.0.0.1'?'http://tapi.pizhigu.com':'http://api.pizhigu.com'
router.beforeEach((to, from, next) => {
  let is_EXP=comp_EXP();   //登录是否过期
  if( to.name=='login' ||  to.name=='agreement'){ 
     is_EXP?router.push('/'):next()
     
  }else if(is_EXP) next();
    else {
      localStorage.setItem('step',true)
      router.push('/login')
    } 
})
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js